module.exports = __webpack_public_path__ + "img/logobitda.762402df.png";